<template>
  <section
    class="
      product-details-img
      d-flex
      border-lg-left
      justify-content-center
      mb-lg-0 mb-4
    "
  >
    <div class="product-details-l-img border-radius10">
      <!-- Swiper -->
      <div v-if="galleries != null"  class="swiper-container h-100 mySwiper">
        <div class="swiper-wrapper">
          <div
            v-for="(image,index) in galleries"
            :key="image.id"
            class="swiper-slide p-2"
          >
            <img :src="image.url" @click="imageView(index)" />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
</template>
<script>
import Swiper from "swiper/swiper-bundle";
import "viewerjs/dist/viewer.css";

export default {
  props: ["galleries", "selectedVariety"],
  data() {
    return {
      images: [],
    };
  },
  computed: {
    currentIndex() {
      if (!this.swiper) {
        return -1;
      }
      return this.swiper.realIndex;
    },
  },
  watch: {
    galleries(newVal) {
      if (newVal == null) {
        return;
      }
      this.galleries.forEach((element,index)=>{
        let pack={
          name:""+index,
          url:element.url
        }
        this.images.push(pack)
      })
      console.log("mounted")
      console.log(this.images)
      this.$imageViewer.images(this.images);
    
      this.initProductDetailSwiper(true);
    },
    selectedVariety(selectedVariety) {
      // بریم به اولین عکس اون تنوع
      if (selectedVariety) {
        this.galleries.findIndex((image) => {
          return image.variety_id == selectedVariety.id;
        });
      }
    },
  },
  mounted() {
   
    this.onResize();
    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
  },
  methods: {
    imageView(index) {
      if (this.images.length == 0) return;
      this.$imageViewer.index(index);
      this.$imageViewer.show();
    },
    initProductDetailSwiper(kill = false) {
      this.initSwiper("product-details-swiper", kill, () => {
        ////swiper slider of product details
        new Swiper(".product-details-l-img .swiper-container", {
          spaceBetween: 1,
          //   centeredSlides: true,
          loop: true,
          speed: 500,

          pagination: {
            el: ".product-details-l-img .swiper-pagination",
            clickable: true,
          },
        });
      });
      this.$nextTick(() => {
        this.onResize();
      });
    },
    onResize() {
      const bodyWidth = document.body.offsetWidth;
      //get height of product-details-img
      const productLargeImg = document.querySelectorAll(
        ".product-details-l-img"
      )[0];
      if (productLargeImg != undefined) {
        if (bodyWidth < 400) {
          productLargeImg.style.width = bodyWidth - 30 + "px";
        }
        if (productLargeImg) {
          console.log(productLargeImg);
          productLargeImg.style.height =
            productLargeImg.offsetWidth / 0.85 + "px";
        }
      }
    },
  },
};
</script>
<style scoped>
.product-details-l-img {
  width: 300px;
  height: 400px;
  background-image: radial-gradient(#fafafa, #f4f4f4, #e1e1e1);
  overflow: hidden;
  text-align: center;
  /*padding-left: 15px;*/
}
.product-details-l-img img {
  max-width: 100%;
  max-height: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
/* 
.product-details-l-img img.main {
  max-width: 100%;
  max-height: 100%;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 8px;
}

.small-pic {
  transform: scale(1);
  transition: 200ms all;
}
.small-pic[active] {
  border: 1px solid #9c9c9c;
  box-shadow: 0 0 5px -2px #8d8d8d;
  transform: scale(1.03);
}

.enlarge {
  cursor: pointer;
  position: absolute;
  width: 27px;
  height: 27px;
  left: 10px;
  top: 10px;
  padding: 6px;
  background: white;
  border-radius: 50%;
  transition: 200ms all;
  user-select: none;
}
.enlarge:hover {
  width: 29px;
  height: 29px;
  left: 9px;
  top: 9px;
}

.enlarge img {
  max-width: 100%;
  max-height: 100%;
  vertical-align: baseline;
  user-select: none;
} */
</style>
<style>
.zoom-on-hover {
  height: 100%;
}

.zoom-on-hover .normal {
  height: 100%;
}

.product-details-img img.zoom {
  cursor: zoom-out;
}

.viewer-canvas > img {
  left: 50%;
  transform: translateX(-50%) !important;
  margin-left: unset !important;
}

.viewer-list {
  width: 100% !important;
}

.viewer-list > li {
  min-width: 40px !important;
}

.viewer-reset {
  display: none !important;
}
.swiper-slide{
  cursor: zoom-in;
}
</style>
